module.exports = __webpack_public_path__ + "img/ub-logo.bd6bbfd1.svg";